import { FC, ReactNode, useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { MasterDataTable } from "../../../components/DataTable/MasterDataTable";
import { TableColumn } from "react-data-table-component";
import { RootState } from "../../../setup";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "bootstrap";
import { Link, useParams } from "react-router-dom";
import { User } from "../../../interfaces/User";
import { AddUser } from "../../../components/user/AddUser";
import { UpdateUser } from "../../../components/user/UpdateUser";
import { DeleteUser } from "../../../components/user/DeleteUser";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Pipeline } from "../../../interfaces/Pipeline";
import { RecentChatHistoryPipeline } from "../../../interfaces/Chat/RecentChatHistory";
import { Log, LogAttachment, PendingLog } from "../../../interfaces/Log";
import { LogAttachments } from "./LogAttachments";
import { SendReportLog } from "./SendReportLog";
import { currencyFormatter, isColorDarkFromHex, isFileUrl } from "../../../functions/general";
import { useIntl } from "react-intl";
import { AddLog } from "./AddLog";
import useUser from "../../../hooks/User";
import { useCustomeStore } from "../../../stores/CustomeStore";
import { ExpandableElement } from "../../General/ExpandableElement";
import { useDataTableStore } from "../../../stores/DataTableStore";
import { useSettingsStore } from "../../../stores/SettingsStore";
import { UserActivity } from "../../../interfaces/UserActivity";
import { ActivityAttachments } from "../../Activities/ActivityAttachment";
import useModalEffect from "../../../hooks/useModalEffect";
import UpdateModalLog from "./UpdateModalLog";
import OTPModal from "./OtpModal";
import { getUserByToken } from "../../../app/modules/auth/redux/AuthCRUD";
import { settings } from "cluster";
import { ExpandableElementProduct } from "./ExpandableElementProduct";
import BadgeTooltip from "../../General/BadgeTooltip";
import { MasterDataTableTanstack } from "../../DataTable/MasterDataTableTanstack";
import { CellContext, ColumnDef } from "@tanstack/react-table";
import { Button } from "react-bootstrap";
import { InvoiceAttachments, InvoiceRenderContext } from "./InvoiceAttachments";
import { useMeetingStore } from "../../../stores/MeetingsStore";
import { useMerchantStore } from "../../../stores/MerchantStore";
import { usePipelineStore } from "../../../stores/PipelineStore";
import axios from "axios";
import useAccessToken from "../../../hooks/AccessToken";
import useSWR, { mutate, useSWRConfig } from "swr";
import { useUserStore } from "../../../stores/UserStore";
import RenderCustomFieldMasterlog from "./RenderCustomFieldMasterlog";
import { InvoiceMultiPageSetting } from "../../../interfaces/Invoices";
import { UpdateDescriptionLogProps } from "../../../api/LogsCRUD";
import ImageModal from "./ImageModal";
import Swal from "sweetalert2";
import { useProductStore } from "../../../stores/ProductStore";
import { getInvoiceGeneratedByLatest } from "../../../api/InvoicesCRUD";
import DetailTerminPipeline from "../DetailTermin/DetailTerminPipeline";
import { checkIsCompanyTanrise, checkIsNewProgress } from "../../../functions/customCase";

type LogProps = {
    lead: any,
    from?: string,
    chatSetLog?: React.Dispatch<React.SetStateAction<Log | undefined>>,
    chatShowLogAttachment?: React.Dispatch<React.SetStateAction<boolean>>,
    closeLogsModalRef?: React.RefObject<HTMLButtonElement>,
    setLead?: (lead: Pipeline | RecentChatHistoryPipeline) => void
    setShow?: React.Dispatch<React.SetStateAction<boolean>>
}

interface UserData {
    id: string;
    name: string;
    username: string;
    phone: string;
}

const API_URL = process.env.REACT_APP_API_URL

const MasterLog: FC<LogProps> = ({ lead, from, setLead, chatSetLog, chatShowLogAttachment, setShow, closeLogsModalRef }) => {
    const location = useLocation();
    const user = useUser();
    const intl = useIntl();
    const { code } = useParams();
    const { settings } = useSettingsStore()
    const { tablesData } = useDataTableStore();
    const { companyId } = useCustomeStore()
    const [log, setLog] = useState<Log>();
    const [showAttachmentModal, setShowAttachmentModal] = useState<boolean>(false);
    const isPipeline = (lead: any): lead is Pipeline => {
        return lead && typeof lead.has_pending_log !== 'undefined';
    };
    const [showAttachmentActivityModal, setShowAttachmentActivityModal] = useState<boolean>(false);
    const [activity, setActivity] = useState<UserActivity>();
    const [url, setUrl] = useState<string>('');
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [showInvoiceModal, setShowInvoiceModal] = useState<boolean>(false)
    const [invoiceContext, setInvoiceContext] = useState<InvoiceRenderContext>('preview')
    const [selectInvoice, setSelectInvoice] = useState<InvoiceMultiPageSetting>()
    const [showAddLogModal, setShowAddLogModal] = useState<boolean>(false);
    const { multiPipelines, setSelectMultiPipeline, simplePipelines, setSimplePipelineLoading, setSimplePipelines, selectMultiPipeline } = usePipelineStore()
    const { simpleMerchants, setSimpleMerchantLoading, setSimpleMerchants } = useMerchantStore()
    const { simpleProducts } = useProductStore()

    const { meetings, setSimpleMeetingLoading, setSimpleMeetings } = useMeetingStore()
    const { users, setUserLoading, setUsers } = useUserStore()
    const token = useAccessToken()
    const [currentUser, setCurrentUser] = useState<UserData | null>(null);
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [displayMode, setDisplayMode] = useState<'activity-pipeline' | 'log' | 'log-history' | 'invoice-files' | 'd-none' | 'detail-termin'>('log');
    const [modalImage, setModalImage] = useState({ show: false, url: '', title: '' });

    const fetcher = async (url: string) => {
        const response = await axios.get(url, {
            headers: {
                'X-Auth-token': token,
            },
        });
        return response.data.data;
    };

    const { data: simpleMerchantsData = [], error: simpleMerchantsError, isLoading: simpleMerchantsLoading } = useSWR(`${API_URL}simple-merchants`, fetcher)
    const { data: simpleMeetingsData = [], error: simpleMeetingsError, isLoading: simpleMeetingsLoading } = useSWR(`${API_URL}simple-meetings`, fetcher)
    const { data: userData = [], error: usersError, isLoading: usersLoading } = useSWR(`${API_URL}users`, fetcher)

    useEffect(() => {
        setSimpleMerchantLoading(simpleMerchantsLoading)
        if (!simpleMerchantsLoading) {
            setSimpleMerchants(simpleMerchantsData)
        }
    }, [simpleMerchantsData]);

    useEffect(() => {
        setSimpleMeetingLoading(simpleMeetingsLoading)
        if (!simpleMeetingsLoading) {
            setSimpleMeetings(simpleMeetingsData)
        }
    }, [simpleMeetingsData]);

    useEffect(() => {
        setUserLoading(usersLoading)
        if (!usersLoading) {
            setUsers(userData)
        }
    }, [userData]);

    useEffect(() => {
        let isMounted = true; // flag komponen masih aktif

        const fetchCurrentUser = async () => {
            try {
                const response = await getUserByToken(token);
                if (isMounted) {
                    setCurrentUser(response.data.data);
                }
            } catch (error) {
                if (isMounted) {
                    console.error("Error fetching current user:", error);
                    Swal.fire({
                        icon: "warning",
                        title: "Error",
                        text: "Unable to fetch user data. Please try again.",
                    });
                }
            }
        };

        if (token) {
            fetchCurrentUser();
        }

        return () => {
            isMounted = false; // cleanup → jangan set state lagi
        };
    }, [token]);

    useEffect(() => {
        if (location.hash === '#approve') {
            setShowOTPModal(true);
            window.history.replaceState(null, "", location.pathname + location.search);
        }
    }, [location.hash]);

    useEffect(() => {
        if (lead && multiPipelines.length > 0) {
            const data = multiPipelines.find(item => item.id === lead.lead_template_id)
            setSelectMultiPipeline(data!)
        }
    }, [multiPipelines, lead])

    const handleManualOpen = () => {
        setShowOTPModal(true);
    };

    const toggleModal = () => {
        setShowOTPModal(!showOTPModal);
    };

    const handleClick = (menuId: string) => {
        setOpenMenuId(menuId);
    };
    const handleClose = () => {
        setOpenMenuId(null);
    };

    useModalEffect({
        showModal: showAttachmentModal,
        setShowModal: setShowAttachmentModal,
        modalId: `attachments-log-modal-${log?.id}`
    });

    useModalEffect({
        showModal: showAttachmentActivityModal,
        setShowModal: setShowAttachmentActivityModal,
        modalId: `attachments-activity-modal-${activity?.id}`
    });

    useModalEffect({
        showModal: showUpdateModal,
        setShowModal: setShowUpdateModal,
        modalId: `update-log-modal-${log?.id}`
    });

    const hasValidAttachments = (attachments: LogAttachment[] | undefined): boolean => {
        if (!attachments || attachments.length === 0) {
            return false;
        }

        const isValidUrl = (url: string): boolean => {
            try {
                new URL(url);
                return true;
            } catch {
                return false;
            }
        };

        return attachments.some(attachment => isValidUrl(attachment.url));
    };

    const isShowBtnAddLog = (row: Pipeline) => {
        const { is_superadmin, permission_pipeline_log_create, company_id } = user.data;
        const isAuthorized = is_superadmin || permission_pipeline_log_create !== 'NONE';
        const isLeadProgressTerm1 = row?.lead_progress_name?.toLocaleLowerCase() === "termin 1";
        const isCompanyMatch = company_id === companyId.uec || company_id === companyId.looyalIT;
        const isLeadInProgress = row?.lead_progress_progress_type !== "FAIL" && row?.lead_progress_progress_type !== "SUCCESS";

        if (selectMultiPipeline.isInfiniteLog) {
            if (selectMultiPipeline.isAllowAfterFailedLog && row?.lead_progress_progress_type === "FAIL") return true
            if (selectMultiPipeline.isAllowAfterSuccessLog && row?.lead_progress_progress_type === "SUCCESS") return true
        } else {
            if (selectMultiPipeline.isAllowAfterFailedLog && row?.lead_progress_progress_type === "FAIL") return true
            if (selectMultiPipeline.isAllowAfterSuccessLog && row?.lead_progress_progress_type === "SUCCESS") return true
        }

        if (isAuthorized && isLeadProgressTerm1 && isCompanyMatch) {
            return true;
        }

        if (isAuthorized && isLeadInProgress) {
            return true;
        }

        return false;
    };

    const handleInvoiceModalClose = (isSubmit: boolean = false) => {
        setShowInvoiceModal(false)
    }

    const handlePreviewInvoice = async (data: PendingLog) => {
        try {
            const getInvoiceSetting = await getInvoiceGeneratedByLatest(token, data.invoiceData[0].progress!.id, data.lead_id);
            // const masterLogInvoiceUrl = `${API_URL}invoices/generated/list?leadId=${data.lead_id}&progressId=${data.invoiceData[0].progress!.id}`
            // mutate(masterLogInvoiceUrl, undefined, { revalidate: true })
            if (getInvoiceSetting.data.success) {
                setShowInvoiceModal(true)
                setInvoiceContext('preview')
                setSelectInvoice(getInvoiceSetting.data.data);
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
                heightAuto: false
            });
        }
    }

    const columnCustomVedaPraxis: TableColumn<Log> = {
        name: 'Product Log',
        width: '400px',
        selector: (row: Log) => JSON.stringify(row.productLog) || '-',
        cell: (row: Log) => {
            if (!row.productLog) return '-';

            // Ambil semua kunci tanggal
            const dates = Object.keys(row.productLog);

            const data = dates.map((date, dateIndex) => {
                const products = row.productLog[date]; // Produk berdasarkan tanggal
                const productEntries = Object.entries(products); // Konversi produk menjadi array [key, value]

                const total = productEntries.reduce((acc: number, [, product]: [string, any]) => {
                    return acc + product.total_price;
                }, 0);

                return (
                    <div key={dateIndex} className="mb-2">
                        <div className="fw-bolder mb-2">
                            {moment(date).format('DD MMM YYYY HH:mm')}
                        </div>

                        <ul>
                            {productEntries.map(([productId, product]: [string, any], index) => {
                                const newValues = (product.price_product);
                                return (
                                    <li key={productId}>
                                        {/* <span className="fw-normal">{product.product_name}</span> - Rp{' '}
                                        {new Intl.NumberFormat('id-ID').format(newValues)} x {product.qty} */}
                                        <span className="fw-normal">{product.product_name}</span> -
                                        {currencyFormatter(newValues, user.data.companyCurrencyNeedRound, user.data.companyCurrency, { showPrefix: true })} x {product.qty}
                                    </li>
                                );
                            })}
                        </ul>

                        <div className="fw-normal">
                            {/* Total: Rp{' '}
                            {new Intl.NumberFormat('id-ID').format(total)} */}
                            Total: {currencyFormatter(total, user.data.companyCurrencyNeedRound, user.data.companyCurrency, { showPrefix: true })}
                        </div>
                        {dateIndex !== dates.length - 1 &&
                            <span className="d-flex justify-content-center my-2">
                                <i className="fas fa-arrow-up"></i>
                            </span>
                        }
                    </div>
                );
            });

            return (
                <ExpandableElementProduct
                    data={data}
                    maxHeight={50}
                />
            );
        }
    };

    const approverDetailColumn: TableColumn<Log> = {
        name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.APPROVER_DETAIL" }),
        width: '250px',
        selector: row => row.approverDetail?.length > 0 ? row.approverDetail.map(approver => approver.name).join(', ') : '-',
        cell: (row) => {
            if (!row.approverDetail || row.approverDetail.length === 0) {
                return '-';
            }

            const approverContent = row.approverDetail.map((approver, index) => (
                <div key={index} className="mb-2">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-bold me-2">{approver.name}</span>
                        {
                            approver.logStatus === 'APPROVED' ? (
                                <span className={`badge badge-success`}>
                                    {intl.formatMessage({ id: "STATUS.APPROVED" })}
                                </span>
                            ) : approver.logStatus === 'NEED_APPROVAL' ? (
                                <span className={`badge badge-warning`}>
                                    {intl.formatMessage({ id: "STATUS.NEED_APPROVAL" })}
                                </span>
                            ) : approver.logStatus === 'REJECTED' ? (
                                <span className={`badge badge-danger`}>
                                    {intl.formatMessage({ id: "STATUS.REJECTED" })}
                                </span>
                            ) : approver.logStatus === 'CANCELLED' ? (
                                <span className={`badge badge-secondary`}>
                                    {intl.formatMessage({ id: "STATUS.CANCELLED" })}
                                </span>
                            ) : (
                                <span className={`badge badge-secondary`}>
                                    {approver.logStatus}
                                </span>
                            )
                        }
                    </div>
                    <label className='text-muted fs-7 fw-bold mb-0'>{intl.formatMessage({ id: "FORM.LABEL.LEVEL" })}: {approver.hierarchyLevel}</label>
                </div>
            ));

            return (
                <ExpandableElement
                    content={
                        <div className="approver-detail-content">
                            {approverContent}
                        </div>
                    }
                    maxHeight={50}
                />
            );
        }
    };

    const approverDetailColumnPending: TableColumn<PendingLog> = {
        name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.APPROVER_DETAIL" }),
        width: '250px',
        selector: row => row.approverDetail?.length > 0 ? row.approverDetail.map(approver => approver.name).join(', ') : '-',
        cell: (row) => {
            if (!row.approverDetail || row.approverDetail.length === 0) {
                return '-';
            }

            const approverContent = row.approverDetail.map((approver, index) => (
                <div key={index} className="mb-2">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-bold me-2">{approver.name}</span>
                        {
                            approver.logStatus === 'APPROVED' ? (
                                <span className={`badge badge-success`}>
                                    {intl.formatMessage({ id: "STATUS.APPROVED" })}
                                </span>
                            ) : approver.logStatus === 'NEED_APPROVAL' ? (
                                <span className={`badge badge-warning`}>
                                    {intl.formatMessage({ id: "STATUS.NEED_APPROVAL" })}
                                </span>
                            ) : approver.logStatus === 'REJECTED' ? (
                                <span className={`badge badge-danger`}>
                                    {intl.formatMessage({ id: "STATUS.REJECTED" })}
                                </span>
                            ) : approver.logStatus === 'CANCELLED' ? (
                                <span className={`badge badge-secondary`}>
                                    {intl.formatMessage({ id: "STATUS.CANCELLED" })}
                                </span>
                            ) : (
                                <span className={`badge badge-secondary`}>
                                    {approver.logStatus}
                                </span>
                            )
                        }
                    </div>
                    <label className='text-muted fs-7 fw-bold mb-0'>{intl.formatMessage({ id: "FORM.LABEL.LEVEL" })}: {approver.hierarchyLevel}</label>
                </div>
            ));

            return (
                <ExpandableElement
                    content={
                        <div className="approver-detail-content">
                            {approverContent}
                        </div>
                    }
                    maxHeight={80}
                />
            );
        }
    };

    const tableColumnLogs: TableColumn<Log>[] = [
        // {
        //     name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }),
        //     center: true,
        //     omit: (user.data.is_superadmin === false),
        //     width: '100px',
        //     id: 'fixedLeft',
        //     cell: (row) => {
        //         const checkIsLoggedIsCreator = user.data.id === row.creator_id;
        //         const logIds = tablesData['logs']?.map(log => log.id) || [];

        //         if (logIds.includes(row.id) && row.id !== tablesData['logs'][tablesData['logs'].length - 1].id && checkIsLoggedIsCreator) {
        //             return (
        //                 <>
        //                     <IconButton
        //                         aria-label={`more-${row.id}`}
        //                         id={`menu-anchor-${row.id}`}
        //                         onClick={() => handleClick(row.id)}
        //                     >
        //                         <MoreVertIcon />
        //                     </IconButton>
        //                     <Menu
        //                         id={`menu-${row.id}`}
        //                         anchorEl={document.getElementById(`menu-anchor-${row.id}`)}
        //                         open={openMenuId === row.id}
        //                         onClose={handleClose}
        //                         disableScrollLock={true}
        //                     >
        //                         <MenuItem onClick={() => {
        //                             handleClose();
        //                             setShowUpdateModal(true);
        //                             setLog(row);
        //                         }}>
        //                             <i className="fas fa-edit fs-4 me-4"></i>
        //                             <span>{intl.formatMessage({ id: "FORM.ACTION.UPDATE_DESCRIPTION" })}</span>
        //                         </MenuItem>
        //                     </Menu>
        //                 </>
        //             );
        //         } else {
        //             return <span>-</span>;
        //         }
        //     }
        // },
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.CREATED_BY" }),
            width: '200px',
            selector: row => row.creator_name === "" ? "-" : row.creator_name,
            cell: row => row.creator_name === "" ? "-" : row.creator_name
        },
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.DATE_STARTED" }),
            width: '200px',
            selector: row => moment(row.date_created).format('dddd, DD MMM YYYY HH:mm'),
            cell: (row) => {
                return moment(row.date_created).format('dddd, DD MMM YYYY HH:mm')
            },
        },
        {
            name: (user.data.company_id === companyId.juraganMaterial || user.data.company_id === companyId.looyalIT) ? intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.PREV_PROGRESS_DURATION" }) : intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.DURATION" }),
            width: '200px',
            selector: row => row.duration,
            cell: (row) => {
                return row.duration
            },
        },
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.PROGRESS" }),
            width: '200px',
            selector: row => row.lead_sub_progress_name ? row.lead_progress_name + " (" + row.lead_sub_progress_name + ")" : row.lead_progress_name,
            cell(row) {
                const progressName = row.lead_progress_name;
                const subProgressName = row.lead_sub_progress_name;
                const progressColor = row.lead_progress_color;
                const newProgress = checkIsCompanyTanrise(companyId, user) ? intl.formatMessage({ id: "FORM.LABEL.CONTACTED" }) : intl.formatMessage({ id: "FORM.LABEL.NEW" })

                const badgeContent = checkIsNewProgress(progressName) ? newProgress : subProgressName ? `${progressName} (${subProgressName})` : progressName;

                const badgeStyle = progressColor
                    ? { backgroundColor: progressColor, color: isColorDarkFromHex(progressColor) ? "white" : "black" }
                    : {};

                let progressBadge;
                if (from === "chat") {
                    progressBadge = (
                        <span className={`badge-ellipsis badge ${progressColor ? '' : 'badge-light-info'}`} style={badgeStyle}>
                            {badgeContent}
                        </span>
                    );
                } else {
                    progressBadge = (
                        <BadgeTooltip tooltipText={badgeContent} badgeClass={progressColor ? '' : 'badge-light-info'} style={badgeStyle}>
                            {badgeContent}
                        </BadgeTooltip>
                    );
                }

                return (
                    <div className="d-flex justify-content-between w-100">
                        {progressBadge}
                        {row.lead_log_status === "NEED_APPROVAL" && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id='tooltip-need-approval'>
                                        {intl.formatMessage({ id: "FORM.LABEL.PENDING_LOG" })}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="d-flex align-items-center ms-2"
                                >
                                    <i className="fas fa-info-circle text-warning fs-5"></i>
                                </div>
                            </OverlayTrigger>
                        )}
                        {row.lead_log_status === "APPROVED" && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id='tooltip-approved'>
                                        {intl.formatMessage(
                                            { id: "FORM.LABEL.APPROVED_LOG" }
                                        )}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="d-flex align-items-center ms-2"
                                >
                                    <i className="fas fa-info-circle text-success fs-5"></i>
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>
                );
            }
        },
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.DESCRIPTION" }),
            width: '400px',
            selector: row => row.description ?? '-',
            cell: row => {
                let descriptionContent = [];

                if (row.description) {
                    descriptionContent.push(<div dangerouslySetInnerHTML={{ __html: row.description }} />);
                }

                if (row.custom_field && row.custom_field.length > 0) {
                    descriptionContent.push(
                        <div className="mt-4">
                            <span className="fw-bolder">Custom Field Updates:</span>
                            <RenderCustomFieldMasterlog
                                row={row}
                                simplePipelines={simplePipelines}
                                simpleMerchants={simpleMerchants}
                                simpleProducts={simpleProducts}
                                meetings={simpleMeetingsData}
                                user={user}
                                users={users}
                            />
                        </div>
                    );
                }

                return (
                    <ExpandableElement
                        content={
                            <div className="custom-field-log">
                                {descriptionContent}
                            </div>
                        }
                        maxHeight={50}
                    />
                );
            },
        },
        approverDetailColumn,
        ...(user.data.company_id === companyId.vedaPraxis || companyId.looyalIT ? [columnCustomVedaPraxis] : []),
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.ATTACHMENT" }),
            width: '100px',
            center: true,
            cell: (row) => {
                return hasValidAttachments(row.attachments) ? (
                    <span role="button" onClick={() => {
                        if (!window.location.pathname.includes('chat')) {
                            setShowAttachmentModal(true);
                            setLog(row);
                        } else {
                            chatSetLog && chatSetLog(row);
                            chatShowLogAttachment && chatShowLogAttachment(true);
                            closeLogsModalRef?.current?.click();
                        }
                    }}>
                        <i className="fas fs-2 fa-eye"></i>
                    </span>
                ) : "-";
            },
        }

    ];

    const tableColumnHistoryLogs: TableColumn<PendingLog>[] = [
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.CREATED_BY" }),
            width: '200px',
            selector: row => row.creator_name === "" ? "-" : row.creator_name,
            cell: row => row.creator_name === "" ? "-" : row.creator_name
        },
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.DATE_STARTED" }),
            width: '200px',
            selector: row => moment(row.date_created).format('dddd, DD MMM YYYY HH:mm'),
            cell: (row) => {
                return moment(row.date_created).format('dddd, DD MMM YYYY HH:mm')
            },
        },
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.PROGRESS" }),
            width: '200px',
            selector: row => row.lead_sub_progress_name ? row.lead_progress_name + " (" + row.lead_sub_progress_name + ")" : row.lead_progress_name,
            cell(row) {
                const progressName = row.lead_progress_name;
                const subProgressName = row.lead_sub_progress_name;
                const progressColor = row.lead_progress_color;

                const newProgress = checkIsCompanyTanrise(companyId, user) ? intl.formatMessage({ id: "FORM.LABEL.CONTACTED" }) : intl.formatMessage({ id: "FORM.LABEL.NEW" })

                const badgeContent = progressName === 'NEW' ? newProgress : subProgressName ? `${progressName} (${subProgressName})` : progressName;

                const badgeStyle = progressColor
                    ? { backgroundColor: progressColor, color: isColorDarkFromHex(progressColor) ? "white" : "black" }
                    : {};

                let progressBadge;
                if (from === "chat") {
                    progressBadge = (
                        <span className={`badge-ellipsis badge ${progressColor ? '' : 'badge-light-info'}`} style={badgeStyle}>
                            {badgeContent}
                        </span>
                    );
                } else {
                    progressBadge = (
                        <BadgeTooltip tooltipText={badgeContent} badgeClass={progressColor ? '' : 'badge-light-info'} style={badgeStyle}>
                            {badgeContent}
                        </BadgeTooltip>
                    );
                }

                return (
                    <div className="d-flex justify-content-between w-100">
                        {progressBadge}
                        {row.lead_log_status === "NEED_APPROVAL" && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip>
                                        {intl.formatMessage({ id: "FORM.LABEL.PENDING_LOG" })}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="d-flex align-items-center ms-2"
                                >
                                    <i className="fas fa-info-circle text-warning fs-5"></i>
                                </div>
                            </OverlayTrigger>
                        )}
                        {row.lead_log_status === "CANCELLED" && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip>
                                        {intl.formatMessage(
                                            { id: "FORM.LABEL.CANCELLED_LOG" }
                                        )}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="d-flex align-items-center ms-2"
                                >
                                    <i className="fas fa-info-circle text-inverse-secondary fs-5"></i>
                                </div>
                            </OverlayTrigger>
                        )}
                        {row.lead_log_status === "APPROVED" && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip>
                                        {intl.formatMessage(
                                            { id: "FORM.LABEL.APPROVED_LOG" }
                                        )}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="d-flex align-items-center ms-2"
                                >
                                    <i className="fas fa-info-circle text-success fs-5"></i>
                                </div>
                            </OverlayTrigger>
                        )}
                        {row.lead_log_status === "REJECTED" && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip>
                                        {intl.formatMessage(
                                            { id: "FORM.LABEL.LOG_REJECTED" }
                                        )}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="d-flex align-items-center ms-2"
                                >
                                    <i className="fas fa-info-circle text-danger fs-5"></i>
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>
                );
            }
        },
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.DESCRIPTION" }),
            width: '400px',
            selector: row => row.description ?? '-',
            cell: row => {
                let descriptionContent = [];

                if (row.description) {
                    descriptionContent.push(<div dangerouslySetInnerHTML={{ __html: row.description }} />);
                }

                if (row.custom_field && row.custom_field.length > 0) {
                    descriptionContent.push(
                        <div className="mt-4">
                            <span className="fw-bolder">Custom Field Updates:</span>
                            <RenderCustomFieldMasterlog
                                row={row}
                                simplePipelines={simplePipelines}
                                simpleMerchants={simpleMerchants}
                                simpleProducts={simpleProducts}
                                meetings={simpleMeetingsData}
                                user={user}
                                users={users}
                            />
                        </div>
                    );
                }

                return (
                    <ExpandableElement
                        content={
                            <div className="custom-field-log">
                                {descriptionContent}
                            </div>
                        }
                        maxHeight={50}
                    />
                );
            },
        },
        approverDetailColumnPending,
        {
            name: intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.ATTACHMENT" }),
            width: '100px',
            center: true,
            cell: (row) => {
                return hasValidAttachments(row.attachments) ? (
                    <span role="button" onClick={() => {
                        if (!window.location.pathname.includes('chat')) {
                            setShowAttachmentModal(true);
                            setLog(row);
                        } else {
                            chatSetLog && chatSetLog(row);
                            chatShowLogAttachment && chatShowLogAttachment(true);
                            closeLogsModalRef?.current?.click();
                        }
                    }}>
                        <i className="fas fs-2 fa-eye"></i>
                    </span>
                ) : "-";
            },
        },
        {
            name: intl.formatMessage({ id: 'FORM.LABEL.INVOICE' }),
            center: true,
            width: '200px',
            cell: (row) => {
                if (row.invoiceData.length > 0) {
                    return (
                        <>
                            <button
                                type='button'
                                className='d-flex items-center gap-2 btn btn-primary btn-sm'
                                onClick={() => {
                                    handlePreviewInvoice(row)
                                }}
                            >
                                Preview
                            </button>
                        </>
                    )
                } else return "-"
            },
        },
    ];

    const tableColumnActivity: TableColumn<UserActivity>[] = [
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.TIME' }),
            selector: row => row.date_created?.toLowerCase() ?? "-",
            sortable: false,
            cell: (row) => {
                return row.date_created && moment(row.date_created).format('dddd, DD MMM YYYY HH:mm')
            }
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.USER' }),
            width: '20%',
            selector: row => row.user_name?.toLowerCase() ?? "-",
            sortable: false,
            cell: row => row.user_name
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTIVITY' }),
            width: '60%',
            selector: row => row.description?.toLowerCase() ?? "-",
            sortable: false,
            cell: (row) => {
                if (row.activity_type === 'INSERT' && row.table_type === 'PIPELINE LOG') {
                    return <div>
                        {
                            row.table_type === 'PIPELINE LOG' ? <span>{row.description}, progres {row.new_data.Progress}, </span>
                                : <span>{row.description}, </span>
                        }
                        <br />
                        <p dangerouslySetInnerHTML={{ __html: row.new_data.Deskripsi }}></p>
                    </div>
                } else {
                    return <p>{row.description}</p>
                }
            }
        },
    ];

    const columns: ColumnDef<any>[] = [
        // {
        //   header: intl.formatMessage({id: 'MASTERS.DATATABLE.COLUMNS.DATE_CREATED'}),
        //   accessorFn: (row) => {
        //     return row.createdAt ? moment(row.createdAt).format('DD MMM YYYY HH:mm') : '-'
        //   },
        // },
        {
            header: intl.formatMessage({ id: 'INVOICE.LABEL.NAME_SETTING' }),
            accessorKey: 'setting.name',
            cell: (props: CellContext<any, unknown>) => {
                const row = props.row.original
                return (
                    <div
                        style={{
                            maxWidth: '400px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 4,
                            padding: '0',
                        }}
                    >{row.setting.name}</div>
                )
            },
        },
        {
            header: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PROGRESS' }),
            accessorKey: 'progress.name',
            cell: (props: CellContext<any, unknown>) => {
                const row = props.row.original
                return (
                    <div>{row.progress.name}</div>
                )
            },
        },
        {
            header: intl.formatMessage({ id: 'INVOICE.COLUMN.DATE_SENT' }),
            accessorFn: (row) => {
                return row.sentToScheduleAt ? moment(row.sentToScheduleAt).format('DD MMM YYYY HH:mm') : '-'
            },
        },
        {
            header: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }),
            cell: (props: CellContext<any, unknown>) => {
                const row: any = props.row.original
                return (
                    <>
                        <button
                            type='button'
                            className='d-flex items-center gap-2 btn btn-primary btn-sm'
                            onClick={() => {
                                setShowInvoiceModal(true)
                                setInvoiceContext('preview')
                                setSelectInvoice(row)
                            }}
                        >
                            Preview
                        </button>

                    </>
                )
            },
        },
    ]

    const handleImageClick = useCallback((e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (target.classList.contains('image-link')) {
            e.preventDefault();
            const imageUrl = target.getAttribute('data-image-url');
            const imageIndex = target.getAttribute('data-image-index');
            if (imageUrl && imageIndex) {
                setModalImage({ show: true, url: imageUrl, title: `Gambar ${imageIndex}` });
            }
        }
    }, []);

    useEffect(() => {
        document.addEventListener('click', handleImageClick);
        return () => {
            document.removeEventListener('click', handleImageClick);
        };
    }, [handleImageClick]);

    let actions: ReactNode[] = [];
    if (user.data.is_allowed_send_report) {
        actions.push(<SendReportLog lead={lead} />)
    }

    if (!window.location.pathname.includes("chat")) {
        actions.push(
            isPipeline(lead) && lead.has_pending_log ? (
                <button
                    type="button"
                    className="btn btn-primary mt-5 mt-md-0"
                    onClick={handleManualOpen}
                >
                    {intl.formatMessage({ id: "FORM.LABEL.APPROVAL" })}
                </button>
            ) : isShowBtnAddLog(lead) ? (
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                        setShowAddLogModal(true)
                    }}
                >
                    {intl.formatMessage({ id: "FORM.ACTION.ADD" })} {intl.formatMessage({ id: "FORM.MENU.LOGS" })}
                </button>
            ) : null
        );
    } else {
        if (isShowBtnAddLog(lead)) {
            actions.push(
                <button
                    type="button"
                    className="btn btn-primary mt-5 mt-md-0"
                    onClick={() => {
                        if (isPipeline(lead) && lead.has_pending_log) {
                            setShowOTPModal(true);
                        } else {
                            setShow!(true)
                        }
                    }}
                >
                    {intl.formatMessage({ id: "FORM.ACTION.ADD" })} {intl.formatMessage({ id: "FORM.MENU.LOGS" })}
                </button>
            )
        }
    }

    useModalEffect({
        showModal: showAddLogModal,
        setShowModal: setShowAddLogModal,
        modalId: `tambah-log-modal`
    })

    return (
        <>
            <div className="card">
                <div className="card-header border-0">
                    <div className="card-title pt-3 mb-0 gap-4 gap-lg-10 gap-xl-10 nav nav-tabs border-bottom-0">
                        <div className={`fs-4 fw-bolder pb-3 cursor-pointer ${displayMode === 'log' ? 'border-bottom border-3 border-primary' : 'text-muted'}`} onClick={() => setDisplayMode('log')}>Log ({tablesData['logs'] ? tablesData['logs'].length : 0})</div>
                        <div className={`fs-4 fw-bolder pb-3 cursor-pointer ${displayMode === 'log-history' ? 'border-bottom border-3 border-primary' : 'text-muted'}`} onClick={() => setDisplayMode('log-history')}>{intl.formatMessage({ id: "FORM.ACTION.LOG_HISTORY" }, { title: settings.pipeline_title })} ({tablesData['log-history'] ? tablesData['log-history'].length : 0})</div>
                        <div className={`fs-4 fw-bolder pb-3 cursor-pointer ${displayMode === 'activity-pipeline' ? 'border-bottom border-3 border-primary' : 'text-muted'}`} onClick={() => setDisplayMode('activity-pipeline')}>{intl.formatMessage({ id: "FORM.LABEL.ACTIVITIES" }, { title: settings.pipeline_title })} ({tablesData['pipeline-activities'] ? tablesData['pipeline-activities'].length : 0})</div>
                        {settings.feature_invoice && (
                            <div className={`fs-4 fw-bolder pb-3 cursor-pointer ${displayMode === 'invoice-files' ? 'border-bottom border-3 border-primary' : 'text-muted'}`} onClick={() => setDisplayMode('invoice-files')} >{intl.formatMessage({ id: 'INVOICE.MENU.FILES' })} ({tablesData['log/invoices'] ? tablesData['log/invoices'].length : 0})</div>
                        )}
                        {Number(lead.paymentTermins.length) > 0 &&
                            <div className={`fs-4 fw-bolder pb-3 cursor-pointer ${displayMode === 'detail-termin' ? 'border-bottom border-3 border-primary' : 'text-muted'}`} onClick={() => setDisplayMode('detail-termin')}>{intl.formatMessage({ id: "FORM.MENU.TERM_DETAILS" })}</div>
                        }

                    </div>
                </div>

                <div className={`${displayMode === "log" ? "" : "d-none"}`}>
                    <MasterDataTable
                        tableKey="logs"
                        tableColumns={tableColumnLogs}
                        apiURL={`lead_logs/?lead_id=${lead.id ?? ''}`}
                        actions={actions}
                        lead={lead}
                    />
                </div>
                <div className={`${displayMode === "log-history" ? "" : "d-none"}`}>
                    <MasterDataTable
                        tableKey="log-history"
                        tableColumns={tableColumnHistoryLogs}
                        apiURL={`pending-logs?lead_id=${lead.id ?? ''}`}
                        actions={actions}
                        lead={lead}
                    />
                </div>
                <div className={`${displayMode === "detail-termin" ? "" : "d-none"}`}>
                    <DetailTerminPipeline pipeline={lead} isModal={false} />
                </div>
                <div className={`${displayMode === "activity-pipeline" ? "" : "d-none"}`}>
                    {
                        <MasterDataTable
                            tableKey="pipeline-activities"
                            tableColumns={tableColumnActivity}
                            apiURL={`user-activities?tableType=PIPELINE&activitySourceId=${lead.id}`}
                            actions={actions}
                            expanded
                            customParams={{ setUrl: setUrl, setActivity: setActivity, setShowAttachmentModal: setShowAttachmentActivityModal }}
                        />
                    }
                </div>
                {settings.feature_invoice && (
                    <div className={`${displayMode === 'invoice-files' ? '' : 'd-none'}`}>
                        <MasterDataTableTanstack
                            tableKey='log/invoices'
                            tableColumns={columns}
                            actions={actions}
                            apiURL={`invoices/generated/list?leadId=${lead.id}`}
                            autoReload={true}
                        />
                    </div>
                )}

                {
                    showAttachmentModal && !window.location.pathname.includes('chat') && <LogAttachments log={log!} />
                }

                {
                    showOTPModal && lead?.id && currentUser && <OTPModal leadId={lead.id} leadProgressId={lead.lead_progress_id} leadTemplateId={lead.lead_template_id} token={token} isOpen={showOTPModal} toggleModal={toggleModal} currentUser={currentUser} />
                }

                {
                    showAttachmentActivityModal && <ActivityAttachments activity={activity!} url={url!} />
                }
                {settings.feature_invoice && selectInvoice && (
                    <InvoiceAttachments
                        lead={lead}
                        invoice={selectInvoice}
                        context={invoiceContext}
                        routerContext='log'
                        showInvoiceModal={showInvoiceModal}
                        handleInvoiceModalClose={handleInvoiceModalClose}
                    />
                )}
                {
                    showUpdateModal && <UpdateModalLog log={log!} onClose={() => setShowUpdateModal(false)} />
                }
                <ImageModal
                    show={modalImage.show}
                    onHide={() => setModalImage({ ...modalImage, show: false })}
                    imageUrl={modalImage.url}
                    title={modalImage.title}
                />
            </div>

            {
                showAddLogModal && <AddLog
                    showModal={showAddLogModal}
                    setShowModal={setShowAddLogModal}
                    lead={lead}
                    setLead={setLead}
                    showAddLogButton={isShowBtnAddLog(lead)}
                />
            }
        </>
    )
}

export { MasterLog }